import { baseConfig } from '../base.config';
import { mix } from '@oec-seller/sdk/m4b-seller-material';

export const REGION_CONFIG = mix(baseConfig, {
  features: {
    showRegionItem: false,
    privacyPolicyLink:
      'https://sf16-sg.tiktokcdn.com/obj/eden-sg/ylauljylsslz_lm_uhsslnht/ljhwZthlaukjlkulzlp/contract/TikTokShop_SellerCenter_PrivacyPolicy_20200528.pdf',
    trackOrigin: 'CB'
  },
  language: {
    switchLang: ['en', 'zh-CN'],
    defaultLang: 'zh-CN'
  }
} as Partial<typeof baseConfig>);
